const scheduleIdleCallback = window.requestIdleCallback || ((cb) => setTimeout(cb, 0));
export default scheduleIdleCallback;
